import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { getList, addData } from "../../helpers/fackBackend_Helper";

function* singleRechargeResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/API/V1/Recharge/SingleRecharge", data);
    if (response?.statusCode == 1200) {
      yield put(actions.singleRechargeSuccess(response?.message));
    } else {
      yield put(actions.singleRechargeFailed(response?.message));
    }
  } catch (error) {
    yield put(actions.singleRechargeFailed(error));
  }
}

function* bulkRechargeResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/API/V1/Recharge/BulkRecharge", data);
    if (response?.statusCode == 1200) {
      yield put(actions.bulkRechargeSuccess(response?.message));
    } else {
      yield put(actions.bulkRechargeFailed(response?.message, response?.data));
    }
  } catch (error) {
    yield put(actions.bulkRechargeFailed(error));
  }
}


export default function* rootSaga() {
  yield all([takeEvery(actions.SINGLE_RECHARGE, singleRechargeResponse),
  takeEvery(actions.BULK_RECHARGE, bulkRechargeResponse)]);
}
